module.exports = __webpack_public_path__ + "assets/img/triangleIcon-85ae25ab.png";